import { useState, useEffect } from "react";
import Modal from '../../../../core/components/core/Util/Modal/CustomModal';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import config from '../../../config/config';

function CancelExpense({ show, onClose, expenseId }) {
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [loading, setLoading] = useState(false);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/expenses/pay`,
        endpointGetAllReasons: `${endpointBackend}gci/reasons/getall`,
    };

    // ---------- FORM CONFIG ----------
    const getForm = (values) => {
        const form = {
            afterSubmit: (form, values) => {
                onClose();
            },
            hiddenValues: {
                gci_expense_id: expenseId,
                status: 'cancelled',
            },
            fields: [
                {
                    name: 'gci_reason_id',
                    type: 'select',
                    label: 'Motivo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllReasons,
                        label: 'name',
                        value: 'id',
                    },
                    validations: { required: true },
                    columnSize: 12
                },
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observação',
                    validations: { required: false },
                    columnSize: 12
                }
            ],
            labelSubmitButton: "Confirmar Cancelamento",
            showGoBackButton: false,
            ...paths,
        };

        form.values = values;
        return form;
    };

    // ---------- LOAD FORM ----------
    useEffect(() => {
        const load = async () => {
            if (!show) return;

            setLoading(true);

            const form = getForm({});
            setForm(form);
            setFormContent(<CustomForm form={form} />);

            setLoading(false);
        };

        load();
    }, [show, expenseId]);

    return (
        <Modal
            show={show}
            handleShow={() => { }}
            handleClose={onClose}
            handleConfirm={() => { }}
            title="Cancelar Despesa"
            content={loading ? "Carregando..." : formContent}
            showButtons={false}
            showHeader={true}
        />
    );
}

export default CancelExpense;
